import React from 'react';
import styles from './pagination.module.scss';
import left from '../../../assets/images/left.png';
import right from '../../../assets/images/right.png';
import ReactPaginate from 'react-paginate';

const Pagination = ({ currentPage, totalItems, handlePageClick }) => {
  return (
    <div>
      <ReactPaginate
        previousLabel={<img src={left} alt="left" />}
        nextLabel={<img src={right} alt="right" />}
        breakLabel={'...'}
        breakClassName={styles.break}
        pageCount={totalItems}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        pageClassName={styles.pagination}
        activeClassName={styles.pageLink2}
        activeLinkClassName={styles.pageLink2}
        previousClassName={styles.arrows}
        nextClassName={styles.arrows}
        forcePage={currentPage - 1}
      />
    </div>
  );
};

export default Pagination;
